export class NativeStandardBackupScheduleConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "frequency",
            "baseName": "frequency",
            "type": "StandardBackupScheduleFrequency",
            "format": ""
        },
        {
            "name": "intervalConfig",
            "baseName": "intervalConfig",
            "type": "NativeStandardIntervalConfig",
            "format": ""
        },
        {
            "name": "dailyConfig",
            "baseName": "dailyConfig",
            "type": "DailyConfig",
            "format": ""
        },
        {
            "name": "weeklyConfig",
            "baseName": "weeklyConfig",
            "type": "WeeklyConfig",
            "format": ""
        },
        {
            "name": "monthlyConfig",
            "baseName": "monthlyConfig",
            "type": "MonthlyConfig",
            "format": ""
        },
        {
            "name": "annuallyConfig",
            "baseName": "annuallyConfig",
            "type": "AnnuallyConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStandardBackupScheduleConfig.attributeTypeMap;
    }
    constructor() {
    }
}
